import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'

type Props = {
  alpha2: Alpha2CountryCode
}

export const getAlpha2WithExceptions = ({ alpha2 }: Props) =>
  (alpha2 === 'PR' ? 'US' : alpha2) as SupportedAlpha2CountryCode
